export class PersonalData
{
  email:string;  
  fullName:string;

  streetNumber:string;
  zipCodeCity:string;
  country:string;
}